import React from 'react';
import { Card, Descriptions } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";

const UserProfile = () => {
    const { user } = useSelector(state => state.user);
    const { t } = useTranslation();
    const na = t('dashboard.notProvided');

    return (
        <Card 
            title={
                <>
                    <UserOutlined style={{ marginRight: 8 }} />
                    <IntlMessage id={'dashboard.user.profile.title'} fallback={'Профиль пользователя'} />
                </>
            }
            style={{ height: '100%' }}
        >
            <Descriptions column={1} bordered>
                <Descriptions.Item label={<IntlMessage id={'username'} fallback={'Имя пользователя'} />}>
                    {user?.username || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'fullName'} fallback={'ФИО'} />}>
                    {user?.profile?.fullName || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'iin'} fallback={'ИИН'} />}>
                    {user?.profile?.iin || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'phone'} fallback={'Контактный телефон'} />}>
                    {user?.profile?.telNumber || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'email'} fallback={'Email'} />}>
                    {user?.profile?.email || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'registrationAddress'} fallback={'Адрес регистрации'} />}>
                    {user?.profile?.registrationAddress || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'residenceAddress'} fallback={'Адрес фактического проживания'} />}>
                    {user?.profile?.residenceAddress || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'businessType'} fallback={'Тип хозяйства'} />}>
                    {user?.profile?.businessType || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'organizationName'} fallback={'Название организации'} />}>
                    {user?.profile?.organizationName || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bin'} fallback={'БИН'} />}>
                    {user?.profile?.bin || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'position'} fallback={'Должность'} />}>
                    {user?.profile?.position || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'authorityBasis'} fallback={'Основание полномочий'} />}>
                    {user?.profile?.authorityBasis || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bankAccount'} fallback={'ИИК (банковский счет)'} />}>
                    {user?.profile?.bankAccount || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bankBik'} fallback={'БИК банка'} />}>
                    {user?.profile?.bankBik || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bankName'} fallback={'Название банка'} />}>
                    {user?.profile?.bankName || na}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'role'} fallback={'Роль'} />}>
                    {user?.role?.roleName?.toUpperCase() || 'USER'}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default UserProfile;